import type { QueryKey } from '@tanstack/react-query';
import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';

type GetIsOrgScanningResponse = {
  scanning: boolean;
};

const DEFAULT_REFETCH_INTERVAL = 1000 * 60; // Poll every 60 seconds
const REFETCH_INTERVAL_WHEN_SCANNING = 1000 * 5; // Poll every 5 seconds

/**
 * Fetches the current scanning status of the organization.
 */
function getIsOrgScanning() {
  return get<GetIsOrgScanningResponse>(`/api/organization/scanning`, false);
}

// This is the query key for the useQuery hook.
export const isOrgScanningQueryKey: QueryKey = ['organization', 'scanning'];

/**
 * Fetches the current scanning status of the organization.
 *
 * @param {boolean} isScanning - Whether or not the organization is currently scanning.
 */
export default function useIsOrgScanning(isScanning: boolean) {
  return useQuery<GetIsOrgScanningResponse>({
    queryFn: getIsOrgScanning,
    queryKey: isOrgScanningQueryKey,
    refetchInterval: isScanning
      ? REFETCH_INTERVAL_WHEN_SCANNING
      : DEFAULT_REFETCH_INTERVAL,
  });
}
